import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Axios from 'axios'

/// Bind i18n to Vue.
export let i18n
Object.defineProperty(Vue.prototype, '$i18n', {
  get() {
    return i18n
  },
})

Vue.use(VueI18n)

const locale = document.documentElement.lang || 'en'
const loadedLanguages = []
export const messageGroups = []

// General message group for general purposes
messageGroups.push('general')

// Create VueI18n instance with options
i18n = new VueI18n({
  locale: locale,
  fallbackLocale: 'en',
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  messages: {},
})

export function configureLocale(locale) {
  i18n.locale = locale
  // Add current locale header to all requests
  Axios.defaults.headers.common['X-Locale'] = locale
  Axios.defaults.headers.common['Accept-Language'] = locale
  document.querySelector('html').setAttribute('lang', locale)
  return locale
}

export function setCurrentLocale(locale) {
  if (loadedLanguages.includes(locale)) {
    configureLocale(locale)
    return Promise.resolve(locale)
  }

  return Axios.get(
    `translations/export?groups=${messageGroups.join(',')}&locale=${locale}`,
  ).then(({ data }) => {
    configureLocale(locale)
    i18n.setLocaleMessage(locale, { ...i18n.messages[locale], ...data })
    loadedLanguages.push(locale)
    return locale
  })
}

// Allow global access
Vue.$i18n = i18n
Vue.$t = (...args) => {
  return i18n.t(...args)
}
Vue.$tc = (...args) => {
  return i18n.tc(...args)
}
